// src/pages/profile/index.js

import React from "react";
import { useAuth } from "auth-context/auth.context";
import Grid from "@mui/material/Grid";
import SuiBox from "components/SuiBox";
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import Footer from "common/Footer";
import Header from "pages/profile/components/Header";
import UserInfo from "pages/profile/components/userInfo";
import UserAttachments from "pages/profile/components/userAttachments";

const ProfileOverview = () => {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  return (
    <DashboardLayout>
      <Header />
      <SuiBox mt={5} mb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} xl={4}>
            <UserInfo userId={String(user._id)} groups={user.groups || []} />
          </Grid>
          <Grid item xs={12} md={6} xl={4}>
            <UserAttachments userIdentification={String(user.identificacion)} />
          </Grid>
          {/* Puedes agregar más componentes aquí si es necesario */}
        </Grid>
      </SuiBox>
      <Footer />
    </DashboardLayout>
  );
};

export default ProfileOverview;
